import { render } from "./RegistrationBinding.vue?vue&type=template&id=7285eafe"
import script from "./RegistrationBinding.vue?vue&type=script&lang=js"
export * from "./RegistrationBinding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__